import Cookies from 'js-cookie';
export var AbFeatures;
(function (AbFeatures) {
    AbFeatures[AbFeatures["APP_1"] = 1] = "APP_1";
    AbFeatures[AbFeatures["OnSiteProposal"] = 2] = "OnSiteProposal";
    AbFeatures[AbFeatures["ClientLiveMessage"] = 3] = "ClientLiveMessage";
    AbFeatures[AbFeatures["Pm2PmLiveMessage"] = 4] = "Pm2PmLiveMessage";
    AbFeatures[AbFeatures["ClientLocationRedesign"] = 5] = "ClientLocationRedesign";
    AbFeatures[AbFeatures["RSP_WODetailRedesign"] = 9] = "RSP_WODetailRedesign";
    AbFeatures[AbFeatures["ClientBIAdvReport"] = 10] = "ClientBIAdvReport";
    AbFeatures[AbFeatures["AutoSchedule"] = 16] = "AutoSchedule";
    AbFeatures[AbFeatures["ClientLocationQS"] = 22] = "ClientLocationQS";
    AbFeatures[AbFeatures["AffiliateCapacity"] = 24] = "AffiliateCapacity";
    AbFeatures[AbFeatures["Sandbox"] = 27] = "Sandbox";
    AbFeatures[AbFeatures["AutoScheduleV3"] = 30] = "AutoScheduleV3";
    AbFeatures[AbFeatures["ClientPermissionGroup"] = 33] = "ClientPermissionGroup";
    AbFeatures[AbFeatures["ClientConfigurationDashboardAndMenu"] = 36] = "ClientConfigurationDashboardAndMenu";
    AbFeatures[AbFeatures["RequestAffiliateDispatch"] = 41] = "RequestAffiliateDispatch";
    AbFeatures[AbFeatures["ClientReportPortalLinkVisible"] = 45] = "ClientReportPortalLinkVisible";
    AbFeatures[AbFeatures["ServiceRequest"] = 46] = "ServiceRequest";
    AbFeatures[AbFeatures["VisitDrivenAndScheduleCalendar"] = 53] = "VisitDrivenAndScheduleCalendar";
    AbFeatures[AbFeatures["OneConnectChat"] = 62] = "OneConnectChat";
})(AbFeatures || (AbFeatures = {}));
export var hasAbFeature = function (feature) {
    var AbKey = "ab-features";
    return [function () { return Cookies.get(AbKey); }, function () { return localStorage.getItem(AbKey); }, function () { return ""; }].
        some(function (provider) { return (provider() || '').split(',').map(function (i) { return parseInt(i, 10); }).indexOf(feature) !== -1; });
};
